var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudSecured(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 10.5L17.675 9.75C16.4 9.15 15.5 7.8 15.5 6.375V1.5H23V6.375C23 7.8 22.175 9.15 20.825 9.75L19.25 10.5ZM17 3V6.375C17 7.275 17.525 8.025 18.275 8.4L19.25 8.85L20.225 8.4C20.975 8.025 21.5 7.2 21.5 6.375V3H17Z",
    fill: "#BE0303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12V16.5H3.5V4.5H12.5V3H3.5C2.675 3 2 3.675 2 4.5V16.5C2 17.325 2.675 18 3.5 18H9.5V21H6.5V22.5H18.5V21H15.5V18H21.5C22.325 18 23 17.325 23 16.5V12H21.5ZM14 21H11V18H14V21Z",
    fill: "#BE0303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSecured);
export default __webpack_public_path__ + "static/media/cloud-secured.4f54d8153e2ef9955e34122edf1d0f59.svg";
export { ForwardRef as ReactComponent };